<template>
<div>
    <section class="section_logo-bar">
        <div class="logonav_wrap">
            <div class="logonav_div">
                <a href="#" class="link-block-73 w-inline-block"><img loading="lazy" src="@/assets/images/OhMyMeds_Logo_w.svg" alt="" class="image-487"></a>

            </div>
        </div>
    </section>
    <section class="checkout-section" v-if="active_el==1">
        <div class="checkoutb_wrap-2">
            <div class="checkoutb_div">
                <div class="upsell_wrap">
                    <div class="upsell-header-div">
                        <div class="text-block-1181">Improve Results.<br>Eliminate Side Effects.</div>
                        <p class="paragraph-15-14">Supercharge your results with instant nausea relief for less than insurance.</p>
                    </div>
                    <div class="reco-box-copy backup individual">
                        <div class="reco-box-top-copy-copy">
                            <div class="div-block-1743"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66fa5efc25c4c009820cbc55_icon_%20RX%20black.svg" alt="" class="image-408">
                                <div class="text-block-1423">Prescricption</div>
                            </div>
                            <div class="category-text">WEIGHT LOSS</div>
                        </div>
                        <div class="reco-box-product-price-copy">
                            <div>
                                <div class="text-block-792-copy">GLP Anti-Nausea</div>
                                <div class="text-block-793">30 Pills</div>
                            </div>
                            <div class="bundle-price-flex">
                                <div class="old-price">
                                    <div class="item-price-div">
                                        <div class="dollar-sign">$</div>
                                        <div class="price-2 old upsell">74</div><img width="69" sizes="69px" alt="" src="@/assets/images/discount-x-01.png" loading="lazy" srcset="@/assets/images/discount-x-01-p-500.png 500w, @/assets/images/discount-x-01-p-800.png 800w, @/assets/images/discount-x-01-p-1080.png 1080w, @/assets/images/discount-x-01-p-1600.png 1600w, @/assets/images/discount-x-01-p-2000.png 2000w, @/assets/images/discount-x-01-p-2600.png 2600w, @/assets/images/discount-x-01-p-3200.png 3200w, @/assets/images/discount-x-01.png 3912w" class="image-450">
                                    </div>
                                </div>
                                <div class="div-block-1745-copy">
                                    <div class="div-block-1744">
                                        <div class="text-block-794">$</div>
                                        <div class="text-block-795-copy">19.97</div>
                                    </div>
                                    <div class="text-block-796-copy">a month</div>
                                </div>
                            </div>
                        </div>
                        <div class="reco-info-box-copy individual">
                            <div class="reco-img-div-copy"><img sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/OhMy_SquareMocks_Zofran-p-500.png 500w, @/assets/images/OhMy_SquareMocks_Zofran-p-800.png 800w, @/assets/images/OhMy_SquareMocks_Zofran.png 1080w" alt="" src="@/assets/images/OhMy_SquareMocks_Zofran.png" loading="lazy"></div>
                            <div class="item-list-div">
                                <div class="text-block-797-copy individual">How it helps</div>
                                <ul role="list" class="list-copy individual">
                                    <li class="list-item">
                                        <div class="text-block-798-copy individual">Instant Nausea Relief</div>
                                    </li>
                                    <li>
                                        <div class="text-block-798-copy">Works in Minutes</div>
                                    </li>
                                </ul>
                                <div class="desk-button-div">
                                    <a href="#" @click.prevent="setMedSelected('Nausea')" class="button-136-copy individual w-button">ADD TO ORDER</a>
                                </div>
                            </div>
                        </div>
                        <div class="mobile-button-div">
                            <a href="#" @click.prevent="setMedSelected('Nausea')" class="button-136-copy individual mobile w-button">ADD TO ORDER</a>
                        </div>
                    </div>
                    <div class="upsell-button-div">
                        <a href="#" @click.prevent="moveToNext()" class="button-113 w-button"><strong>&quot;I&#x27;m Not Interested in Eliminating My Side Effects&quot;</strong> <span class="text-span-254">-&gt;</span></a>
                    </div>
                </div>
            </div>
        </div>
    </section>          
    <section class="checkout-section" v-if="active_el==2">
        <div class="checkoutb_wrap">
            <div class="checkoutb_div">
                <div class="ty_maindiv">
                    <div class="text-block-1403">You made the right choice {{user.first_name}}!</div>
                    <div class="text-block-1400">Your Current Medical Weight Loss Regimen:</div>
                    <div class="productbar_div">
                        <div class="barflex">
                        <div class="img-and-text-div">
                            <div class="img-div-box">
                                <img  src="@/assets/images/OhMy_Vial_TIRZ.png" loading="lazy" alt="" class="image-612" v-if="getProductName === 'Tirzepatide'">
                                <img  src="@/assets/images/OhMy_Vial_SEMA.png" loading="lazy" alt="" class="image-612" v-else>
                            </div>
                            <div class="barinfo_div">
                            <div class="bar-header">
                                <div class="bar-header-text">{{getProductName}}</div>
                                <div class="text-block-1402">weekly injection</div>
                            </div>
                            <div class="bar-subheader-text">All Dosage Levels...same price!</div>
                            <div class="bar-body-text">Remove food noise, eat less and drop weight fast with a once weekly mini-injection</div>
                            </div>
                        </div>
                        <div class="barprice_div">
                            <div class="div-block-2085">
                            <div class="text-block-1406"></div>
                            <div class="text-block-1404"></div>
                            <div class="text-block-1405"></div>
                            </div>
                            <div class="text-block-1407"></div>
                        </div>
                        </div><img loading="lazy" src="@/assets/images/icon_check_wht.svg" alt="" class="image-563">
                    </div>
                </div>
                <div class="productbar_div gift"  v-if="selectedOption==='Nausea'">
                    <div class="barflex">
                        <div class="img-and-text-div">
                        <div class="img-div-box"><img src="@/assets/images/OhMy_ZofranPills.png" loading="lazy" alt="" class="image-612"></div>
                        <div class="barinfo_div gift">
                            <div class="bar-header gift">
                            <div class="bar-header-text">GLP Anti-Nausea</div>
                            <div class="text-block-1402"><strong>30</strong> Pills</div>
                            </div>
                            <div class="bar-subheader-text">4mg Generic Zofran® (ondansetron)</div>
                            <div class="bar-body-text gift">Eliminate nausea, the most common GLP side effect in one easy to take melt-away tablet.</div>
                        </div>
                        </div>
                        <div class="barprice_div">
                            <div class="div-block-2085">
                            <div class="text-block-1406">$</div>
                            <div class="text-block-1404">19</div>
                            <div class="text-block-1405">97</div>
                            </div>
                            <div class="text-block-1407">Monthly</div>
                        </div>
                    </div><img loading="lazy" src="@/assets/images/icon_check_wht.svg" alt="" class="image-563">
                </div>
                <div class="ty_buttondiv">
                    <button @click="addBundleAndMove()" class="button-134 w-button" :disabled="submitting">
                        <div v-if="submitting">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                </circle>
                            </svg>
                        </div>
                        <div v-else>
                            <div class="">Next Step <span class="text-span-247">-&gt;</span></div>
                        </div>
                    </button>
                    <div class="w-form-fail" style="display:block" v-if="showError">
                        <div>{{errorMessage}} </div>
                    </div>
                </div>
            </div>
            <div style="height: 220px;"></div>
        </div>

    </section>

</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';

export default {
    name: 'UpsellMeds',
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            active_el: 1,
            selectedOption: '',
            submitting: false,
            showError: false,
            errorMessage: '',
        }
    },
    computed: {
        ...mapGetters(['getRemainingPrescriptions', 'user']),
        remainingPrescriptions() {
            return this.getRemainingPrescriptions;
        },
        getDrugName() {
            return this.selectedOption === '' ? 'GLP Anti-Nausea and GLP Energy' : this.selectedOption === 'B12' ? 'GLP Anti-Nausea' : 'GLP Energy'
        },

        paymentTerms() {
            let temp = this.$route.query.terms ? Number(this.$route.query.terms) || 1 : 1;
            if (temp == 6 || temp == 3) {
                return temp / 3;
            }
            return 1;
        },
        getImage() {
            console.log(this.getProductName)
            if (this.getProductName === 'Tirzepatide') {
                return "https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp"
            } else {
                return "https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/semaglutide/1.webp"
            }
        },
        getProductName() {
            return JSON.parse(localStorage.getItem("productName"))
        },
    },
    watch: {
        active_el() {
            window.scrollTo(0, 0)
        }
    },
    methods: {
        integerPart(value) {
            return Math.floor(value); // Extracts the whole number part
        },
        decimalPart(value) {
            const decimalStr = (value % 1).toFixed(2).split('.')[1];
            return decimalStr || '00'; // Ensures two decimal places
        },
        setMedSelected(value) {
            this.selectedOption = value;
            this.moveToNext();
        },
        moveToNext() {
            this.active_el = 2;
        },
        async fireGTM() {
                try {
                    const amount = this.$route.query.amount;
                    const transid = this.$route.query.trans_id;
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'purchase',
                        'ecommerce': {
                            'transaction_id': transid,
                            'value': amount,
                            'currency': 'USD',
                        }
                    });
                    console.log(":white_check_mark: Google pixel fired with amount:", amount);
                } catch (error) {
                    console.error(":x: Error firing Google pixel:", error);
                }
                
        },
        async addBundleAndMove() {
            try {
                this.submitting = true;
                const response = await this.$axios.post(`${this.baseUrl}/api/bundle-selected`, {
                    selectedMed: this.selectedOption || "None",
                    terms: this.paymentTerms
                });

                if (response.data.status === "success") {
                    this.$router.push({
                        name: "showStepsToUser"
                    });
                } else {
                    this.showError = true;
                    this.errorMessage = response.data.message || "An unexpected error occurred.";
                    this.submitting = false;
                }

            } catch (error) {
                this.showError = true;
                this.errorMessage = error.response?.data?.message || "Something went wrong. Please try again.";
                console.error("Error in addBundleAndMove:", error);
                this.submitting = false;
            }
        },
    },
    mounted() {
        this.fireGTM();
    }
}
</script>
